import {
    Badge,
    Button,
    Flex,
    FormControl,
    FormLabel,
    Input,
    Switch,
    Td,
    Textarea,
    Tr,
    VStack,
    useDisclosure,
    useToast,
} from '@chakra-ui/react';
import { useRef, useState } from 'react';
import { MdOutlineDataSaverOn } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { updateApplicant, sendApplicantEmail } from '../redux/actions/groupClassActions';

const ApplicantTableItem = ({applicant}) => {
    const { userInfo } = useSelector((state) => state.user);
    const { groupClass } = useSelector((state) => state.groupClass);
    const toast = useToast();
    const cancelRef= useRef();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [ isApproved, setIsApproved ] = useState(applicant.isApproved);
    const [ratingInThis, setRatingInThis ] = useState(applicant.ratingInThis);
    const [secretNote, setSecretNote ] = useState(applicant.secretNote);
    const [emailTitle, setEmailTitle ] = useState('');
    const [emailContent, setEmailContent ] = useState('');
    
    const dispatch = useDispatch();

    const onSaveApplicant = () => {
        dispatch(updateApplicant(applicant.name, applicant.level, ratingInThis, secretNote, applicant.email, applicant.userId, isApproved));
        toast({
            description: `Applicant ${applicant.name} is updated.`,
            status: 'success',
            isClosable: true,
        });
        if(isApproved) {
            setEmailTitle("Congratulations! Your application is approved !");
            setEmailContent(`Dear ${applicant.name},
 
    Congratulations, you are approved to join the ${groupClass.title} at Qishi. 
    
    Please sign the Non-disclosure Agreement we sent to confirm that you will abide by Qishi's terms and conditions.

    P.S. Please provide us with your Wechat ID. More information will be shared with you via Wechat shortly. 

Thanks,
The Studying Management Team at Qishi
`);
        } else {
            setEmailTitle("Sorry, your application is not approved.");
            setEmailContent(`Dear ${applicant.name},

    Thank you for showing interest in the ${groupClass.title} at Qishi. We are impressed by your background, 
but after careful consideration, we regret to inform you that you have not been selected for this activity 
due to limited opening formal member positions. However, you are highly encouraged to apply for the non-credit 
version of this study group if there is any，which will provide you exactly the same exposure as the formal member. 
The only difference is there is no need to give a presentation.

    We hope our paths cross again and encourage you to subscribe and search for other activity opportunities 
that might be of interest to you on our programs page. We would launch the activity when there are enough subscribers. 
At the same time, please watch out for our next related study group. 

    Thank you for your interest in us.

Best regards,
The Studying Management Team at Qishi
`);
        }

    };

    const onSendApplicantEmail = () => {
      dispatch(sendApplicantEmail(emailTitle, emailContent, applicant.email, applicant.name));
      toast({
          description: `Email to Applicant ${applicant.name} is sent.`,
          status: 'success',
          isClosable: true,
      });
      setEmailContent('');
      setEmailTitle('');
  };

  return (
    <>
    <Tr>
                              <Td> Name: </Td>
                              <Td> {applicant.name}</Td>
                            </Tr>
                            <Tr>
                              <Td> Email: </Td>
                              <Td> {applicant.email}</Td>
                            </Tr>
                            <Tr>
                              <Td> WechatId: </Td>
                              <Td> {applicant.wechatId ? applicant.wechatId : ''}</Td>
                            </Tr>
                            <Tr>
                              <Td> is Approved : </Td>

                              <Td>
                                <FormControl display='flex' alignItems='center'>
                                    <FormLabel htmlFor='isApprovedFlag' mb='0' fontSize='sm'>
                                        Set
                                        <Badge rounded='full' px='1' mx='1' fontSize='0.8m' colorScheme='green'>
                                            is Approved
                                        </Badge>
                                    </FormLabel>
                                    <Switch id='isApprovedFlag' onChange={() => setIsApproved(!isApproved)} isChecked={isApproved} />
                                </FormControl>
                              </Td>
                            </Tr>
                            <Tr>
                            <Td> Rating: </Td>
                            <Td>
                            <Input size='sm' value={ratingInThis} onChange={(e) => setRatingInThis(e.target.value)} />
                           </Td>
                        </Tr>
                            <Tr>
                            <Td> Secret Memo Note: </Td>
                            <Td>
                                <Textarea
                                    w='80vh' 
                                    h='120px'
                                    value={secretNote}
                                    onChange={(e) => setSecretNote(e.target.value)}
                                    size='m'
                                />
                           </Td>
                        </Tr>
                        <Tr>
                            <Td>Action</Td>
                            <Td>
                                <Button colorScheme='green' variant='outline' onClick={onSaveApplicant}>
                                <MdOutlineDataSaverOn style={{marginRight: '5px'}} />
                                    Save Changes
                                </Button>
                            </Td>
    </Tr>
    <Tr>
                            <Td> Title: </Td>
                            <Td>
                            <Input size='sm' value={emailTitle} onChange={(e) => setEmailTitle(e.target.value)} />
                           </Td>
                        </Tr>
    <Tr>
                            <Td> Content: </Td>
                            <Td>
                                <Textarea
                                    w='80vh' 
                                    h='120px'
                                    value={emailContent}
                                    onChange={(e) => setEmailContent(e.target.value)}
                                    size='m'
                                />
                           </Td>
                        </Tr>                    
                        <Tr>
                            <Td>Action</Td>
                            <Td>
                                <Button colorScheme='green' variant='outline' onClick={onSendApplicantEmail}>
                                <MdOutlineDataSaverOn style={{marginRight: '5px'}} />
                                    Send Email to {applicant.name}
                                </Button>
                            </Td>
    </Tr>
    </>
  );
};

export default ApplicantTableItem;